import axios from 'axios'

class DesentranhamentoDocumentoApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async criarTermoDesentranhamento(idDocumento, tipoDocumento) {
		const payload = { tipoDocumento, idDocumento }
		return await axios.post(this.urlBuilder.desentranhamento.getUrlCriarTermo(idDocumento), payload)
	}

	async juntarTermoDesentranhamento(idDocumento, tipoDocumento) {
		const payload = { tipoDocumento, idDocumento }
		return await axios.put(this.urlBuilder.desentranhamento.getUrlJuntarTermo(idDocumento), payload)
	}
}

export default DesentranhamentoDocumentoApiClient
